import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";

export default function Auspiciadores() {
    return (
        <section className="auspiciadores">
            <h2 className="titulo">Quienes hacen posible este encuentro</h2>
            <div className="bloque">
                <div className="titles">
                    <hr />
                    <h3 className="subtitulo">Organizador</h3>
                    <hr />
                </div>
                <img src="/images/logoME.png" alt="Comisión Mujeres Empresarias" className="logo-camara" />
            </div>

            {/* <div className="bloque">
                <div className="titles">
                    <hr />
                    <h3 className="subtitulo">Coorganizadores</h3>
                    <hr />
                </div>
                <Swiper
                    modules={[Autoplay]}
                    autoplay={{ delay: 2000 }}
                    spaceBetween={30}
                    slidesPerView={3}
                    centeredSlides={true}
                    loop={true}
                    className="swiper-logos"
                >
                    <SwiperSlide><img src="/images/logo_cerroverde.png" alt="Logo 1" className="logo" /></SwiperSlide>
                    <SwiperSlide><img src="/images/logo_bcp.png" alt="Logo 1" className="logo" /></SwiperSlide>
                </Swiper>
            </div> */}

            <div className="bloque">
                <div className="titles">
                    <hr />
                    <h3 className="subtitulo">Auspiciadores</h3>
                    <hr />
                </div>

                <img src="/images/logo_cerroverde.png" alt="Logo 3" className="logo-principal" />
                <img src="/images/logo_kori.png" alt="Logo 2" className="logo-principal" />
                <img src="/images/logo_ucsm.png" alt="Logo 1" className="logo-principal" />
                <img src="/images/logo_spm.png" alt="Logo 1" className="logo-principal" />
                <img src="/images/logo_mass.png" alt="Logo 1" className="logo-principal" />
                <img src="/images/logo_lampein.png" alt="Logo 1" className="logo-principal" />
                <img src="/images/logo_diario.png" alt="Logo 1" className="logo-principal" />
                <img src="/images/logo_womenceo.png" alt="Logo 1" className="logo-principal" />
                <div className="small-logos">
                    <img src="/images/logo_claudia.png" alt="Logo 1" className="logo-principal" />
                    <img src="/images/logo_kinnefit.png" alt="Logo 1" className="small-logo" />
                    <img src="/images/logo_kaffeehaus.png" alt="Logo 1" className="small-logo" />
                    <img src="/images/logo_flit.png" alt="Logo 1" className="small-logo" />
                    <img src="/images/logo_acolpacha.png" alt="Logo 1" className="logo-principal" />
                    <img src="/images/logo_corregidor.png" alt="Logo 1" className="small-logo" />
                </div>
            </div>

            {/* <div className="bloque">
                <div className="titles">
                    <hr />
                    <h3 className="subtitulo">Alianzas Estratégicas</h3>
                    <hr />
                </div>
                <Swiper
                    modules={[Autoplay]}
                    autoplay={{ delay: 2000 }}
                    spaceBetween={30}
                    slidesPerView={3}
                    centeredSlides={true}
                    loop={true}
                    className="swiper-logos"
                >
                    <SwiperSlide><img src="/images/logo_ucsm.png" alt="Logo 1" className="logo" /></SwiperSlide>
                </Swiper>
            </div> */}

            <div className="details-bottom">
                <p>¿Quieres ser auspiciador?</p>
                <a href="https://wa.link/42028k" target="_blank"><button className="btn-preventa">Contáctanos</button></a>
            </div>
        </section>
    );
}
